import React from 'react';
import {
  Grid,
  Box,
  makeStyles,
  Container,
  Typography,
  Divider,
  Hidden,
  useMediaQuery,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { theme } from '../../App';
import IngredientsCartImage from '../../assets/images/IngredientsCartImage.svg';

const useStyles = makeStyles((theme) => ({
  container: {},
  root: {
    background: 'black',
    height: 2,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
}));

const IngredientsIntroSection = () => {
  const store = useSelector((state) => state);
  const dispatch = useDispatch();
  const classes = useStyles();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      container
      justify='space-between'
      style={{ paddingBottom: '15vh', paddingTop: '10vh' }}
    >
      <Grid item xs={12} md={7}>
        <Box>
          <Typography variant='h1' style={{ textAlign: sm && 'center' }}>
            Farmer's Market
          </Typography>
          <Hidden smDown>
            <Divider classes={{ root: classes.root }} />
          </Hidden>
          <Hidden mdUp>
            <object
              type='image/svg+xml'
              data={IngredientsCartImage}
              style={{ marginTop: 20, marginBottom: 20 }}
            >
              <img src={IngredientsCartImage} alt='ingredients cart' />
            </object>
          </Hidden>
          <Typography
            variant='body1'
            style={{ paddingRight: theme.spacing(1) }}
          >
            Welcome to the Farmer’s Market ! OneRare Farmers come to our
            marketplace to sell their freshest produce. <br />
            {sm && <br />} Get going on your Shopping List & collect all the
            Ingredients you need for your Recipe !
          </Typography>
        </Box>
      </Grid>
      <Hidden smDown>
        <Grid item xs={12} sm={4}>
          <object type='image/svg+xml' data={IngredientsCartImage}>
            <img src={IngredientsCartImage} alt='ingredients cart' />
          </object>
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default IngredientsIntroSection;
